<template>
  <base-dialog
    v-model="visible"
    class="create-page-dialog"
    title="添加页面"
    width="460px"
    :modal="true"
    :offset="[56,0,0,0]"
    :modal-append-to-body="false"
  >
    <el-form
      ref="form"
      class="create-page-form"
      label-position="top"
      :model="form"
      :rules="rules"
    >
      <el-form-item label="页面名称" prop="name">
        <base-input v-model="form.name" type="text" placeholder="页面名称" show-word-limit maxlength="60" />
      </el-form-item>
      <el-form-item label="描述" prop="describe">
        <base-input v-model="form.describe" :rows="4" resize="none" placeholder="页面描述" type="textarea" show-word-limit maxlength="200" />
      </el-form-item>
      <el-form-item class="link" label="页面链接" prop="link">
        <base-input v-model="form.link" placeholder="请输入">
          <template slot="prepend">{{ `https://${domain}/` }}</template>
        </base-input>
      </el-form-item>
    </el-form>
    <div class="create-page-footer">
      <base-button @click="handleCancel">取消</base-button>
      <base-button type="primary" @click="handleSubmit">保存</base-button>
    </div>
  </base-dialog>
</template>

<script>
import { Form, FormItem, Message } from 'element-ui'
import { PatternEnum } from '~/enums/pattern'
import BaseDialog from '~/components/base/baseDialog'
import BaseInput from "~/components/base/baseInput"
import BaseButton from "~/components/base/BaseButton.vue"
export default {
  components: {
    BaseDialog,
    ElForm: Form,
    ElFormItem: FormItem,
    BaseInput,
    BaseButton
  },
  props: {
    domain: {
      type: String,
      default: ''
    }
  },
  data() {
    const checkLink = (rule, value, callback) => {
      const reg = PatternEnum.PAGE_LINK
      if (reg.test(value)) {
        return callback()
      } else {
        return callback(new Error('必须为字母，长度最小为2且不超过20'))
      }
    }
    return {
      visible: false,
      form: {
        name: '',
        describe: '',
        link: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入页面名称' }
        ],
        describe: [
          { required: false, message: '请输入页面描述' }
        ],
        link: [
          { required: true, validator: checkLink }
        ]
      }
    }
  },
  methods: {
    init() {
      this.visible = true
      this.$nextTick(() => {
        this.$refs.form.resetFields()
      })
    },
    handleCancel() {
      this.visible = false
    },
    checkForm() {
      return new Promise((resolve) => {
        this.$refs.form.validate(flag => {
          resolve(flag)
        })
      })
    },
    async handleSubmit() {
      const isRight = await this.checkForm()
      if (!isRight) {
        return
      }
      const { name, link, describe } = this.form
      const params = {
        site_builder_id: this.$store.state.project.info.id,
        name,
        link,
        desc_content: describe
      }
      const [err, res] = await this.$utils.to(this.$api.siteBuild.createPage(params))
      if (!err) {
        Message.success('页面添加成功')
        const page = {
          ...res,
          id: res.id.toString(),
          value: res.name
        }
        this.SitePage.append(page)
        this.handleCancel()
      } else {
        Message.error(err)
      }
    }
  }
}
</script>

<style lang="less">
.create-page-dialog {
  .create-page-form {
    padding: 4px 4px 0;

    .el-form-item {
      margin-bottom: 20px;

      &:last-child {
        margin-bottom: 4px;
      }
    }

    .el-form-item__label {
      color: var(--text-color);
      font-size: 13px;
      font-weight: 500;
      line-height: 1.5;
      padding: 0 0 6px;
    }

    .el-form-item__error {
      color: #ff7875;
      padding-top: 4px;
    }

    &.link .el-input__inner {
      padding-left: 10px;
    }
  }

  .create-page-footer {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin: 20px -24px -24px;
    padding: 14px 24px;
    border-top: 1px solid var(--border-color-base);
  }
}
</style>
